import { GetFrontalClass } from './FadingArrow';

const StartOrderIndexItem = (props) => {
  const inStart = props.mode === 'start';
  return (
    <span
      onClick={inStart ? () => { props.activateParticipant(props.id); } : undefined}
      onDoubleClick={inStart ? () => { props.hide(props.id); } : undefined}
      className={
        "style-frontal style-order-list" +
        GetFrontalClass(props.completed, props.choose) +
        (inStart ? ' style-order-list-clickable' : '')
      }>
      {props.ident}
    </span>
  );
};

export default StartOrderIndexItem;
